import React, { useEffect, useState } from 'react';
import './index.scss';
import {
    Button,
    Col,
    Divider,
    Image,
    Row,
    Typography,
    notification,
    Space,
    Form,
    Input, Upload, Spin, Select, Skeleton, InputNumber, Switch, DatePicker,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import arrowLeft from '../../../src/img/arrow-left.png';
import {
    UploadOutlined,
    ArrowLeftOutlined,
} from '@ant-design/icons';

import API_SERVICE from 'shared/services/api-service';
import { getImageUrl, UploadImage } from 'shared/services/Utility';
import moment from 'moment';
import { fillEn } from '../../methods/forms';
import { AuthConsumer } from 'shared/contexts/AuthContext';

interface Props {
    location: any;
    hideHeader?: boolean
}

const { Title } = Typography;
const { Option } = Select;
export default function MeetingForm(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams: any = useParams();
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [item, setItem] = useState(null as any);
    const [courseAuthorId, setCourseAuthorId] = useState(null as any);
    const [uploading, setUploading] = useState(false);
    const refreshItem = async () => {
        try {
            setFetching(true);
            const {
                data: { data },
            } = await API_SERVICE.fetchMeetingByIdAdmin(RouteParams['courseId'], RouteParams['id']);
            setItem({
                ...data,
            });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };

    const refreshCourseItem = async () => {
        try {
          setFetching(true);
            const {
                data: { data },
            } = await API_SERVICE.fetchCourseByIdAdmin(RouteParams['courseId']);
            setCourseAuthorId(data.author.id)
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
          setFetching(false);
        }
    };

    useEffect(() => {
        if (RouteParams['courseId']) {
            refreshCourseItem();
        }
        if (RouteParams['id']) {
            refreshItem();
        } else {
            setFetching(false);
        }
    }, []);

    if (fetching) {
        return <Skeleton active={true} />;
    }
    return (
        <AuthConsumer>
            {({ user }) => (
                (user?.id == courseAuthorId) || user?.role?.id == 2 || courseAuthorId == null && (user?.role?.slug !== 'STUDENT') ?
                    <div className={'list-page-wrapper'}>
                        <div className="container-fluid">
                            <div className='row mb-3'>
                                <div className='col-md-12 p-0 d-flex align-items-center'>
                                    <div className='mr-4'>
                                    <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                                    </div>
                                    <div><h3 className='mb-0'>{RouteParams['mode'] === 'create' ? t('meeting.create') : ''}</h3></div>
                                    <div><h3 className='mb-0'>{RouteParams['mode'] === 'view' ? t('meeting.profile') : ''}</h3></div>
                                    <div><h3 className='mb-0'>{RouteParams['mode'] === 'edit' ? t('meeting.edit') : ''}</h3></div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    
                                    <div className='bg-white p-3 br-5px'>
                                        <div className="form-fields pl-4 pr-6rem pt-3 pb-3">
                                        <Form
                                    size='large'
                                    form={form}
                                    initialValues={item}
                                    fields={[]}
                                    onFinish={(value) => {
                                        const reqObj: any = fillEn({
                                            ...value,
                                        is_recording_on: value.is_recording_on ? 1 : 0,
                                            start_date_time: value.start_date_time.format('YYYY-MM-DD HH:mm:ss'),
                                            end_date_time: value.end_date_time.format('YYYY-MM-DD HH:mm:ss'),
                                        });

                                        setSaving(true);
                                        API_SERVICE.createMeeting(RouteParams['courseId'], reqObj).then((d) => {
                                            history.goBack();
                                        }).catch((e) => {
                                            notification.error({ message: API_SERVICE.handleErrors(e) });
                                            setSaving(false);
                                        });
                                    }}
                                    layout='vertical'
                                    requiredMark={true}
                                >
                                            <Row>
                                                <Col lg={10} md={10} sm={24} xs={24}>
                                                <h5>Meeting Information</h5>
                                                <p className="text-secondary">This Information will be display the logo of the organisation</p>
                                                </Col>
                                                <Col lg={14} md={14} sm={24} xs={24}>
                                                <Form.Item
                                                    label={t('meeting.titleDe.label')}
                                                    name={['title', 'de']}
                                                    rules={[
                                                        { required: true, message: t('meeting.titleDe.required') },
                                                    ]}
                                                >
                                                    <Input className='br-1' disabled={!RouteParams['mode']} />
                                                </Form.Item>
                                                <Form.Item
                                                    label={t('meeting.title.label')}
                                                    name={['title', 'en']}
                                                    rules={[
                                                    ]}>
                                                    <Input className='br-1' disabled={!RouteParams['mode']} />
                                                </Form.Item>
                                                <Form.Item
                                                    label={t('meeting.descriptionDe.label')}
                                                    name={['description', 'de']}
                                                    rules={[
                                                        { required: true, message: t('meeting.descriptionDe.required') },
                                                    ]}
                                                >
                                                    <Input className='br-1' disabled={!RouteParams['mode']} />
                                                </Form.Item>
                                                <Form.Item
                                                    label={t('meeting.description.label')}
                                                    name={['description', 'en']}
                                                    rules={[
                                                    ]}>
                                                    <Input className='br-1' disabled={!RouteParams['mode']} />
                                                </Form.Item>
                                                <Form.Item
                                                    label={t('meeting.isRecordingOn.label')}
                                                    name='is_recording_on'
                                                    valuePropName={'checked'}
                                                    rules={[]}
                                                >
                                                    <Switch disabled={RouteParams['mode'] === 'view'} />
                                                </Form.Item>
                                                <Form.Item
                                                    label={t('meeting.startDate.label')}
                                                    name='start_date_time'
                                                    rules={[
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                if (!value) {
                                                                    return Promise.reject(
                                                                        t('meeting.startDate.required'),
                                                                    );
                                                                }
                                                                if (moment().subtract('day', 1).unix() < value.unix()) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject(
                                                                    t('meeting.startDate.shouldBeGreaterThanToday'),
                                                                );
                                                            },
                                                        }),
                                                    ]}
                                                >
                                                    <DatePicker className='br-1' showTime={true} />
                                                </Form.Item>
                                                <Form.Item
                                                    label={t('meeting.endDate.label')}
                                                    name='end_date_time'
                                                    rules={[
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                if (!value) {
                                                                    return Promise.reject(
                                                                        t('meeting.endDate.required'),
                                                                    );
                                                                }
                                                                if (getFieldValue('start_date_time') && getFieldValue('start_date_time').unix() < value.unix()) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject(
                                                                    t('meeting.endDate.shouldBeLessThanStartDateTime'),
                                                                );
                                                            },
                                                        }),
                                                    ]}
                                                >
                                                    <DatePicker className='br-1' showTime={true} />
                                                </Form.Item>                                        
                                                </Col>
                                            </Row>
                                            <hr/>
                                            {
                                                RouteParams['mode'] !== 'view' && <Form.Item>
                                                    <Button
                                                        htmlType="submit"
                                                        loading={saving || uploading}
                                                        size={'large'}
                                                        className="submit btn-blue float-right"
                                                    >
                                                        {t('genDict.save')}
                                                    </Button>
                                                    <Button                                 
                                                        htmlType="reset"
                                                        size={'large'}
                                                        className="reset mr-3 btn-default float-right"
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Form.Item>
                                            }
                                            </Form>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        {/* <Row gutter={20} justify={'space-between'}>
                            <Col flex={'auto'}>
                                <Space align={'start'}>
                                    <Button type={'link'} onClick={() => history.goBack()} icon={<ArrowLeftOutlined />} />
                                    <Title
                                        level={3}>{RouteParams['mode'] === 'create' ? t('meeting.create') : ''}</Title>
                                </Space>
                            </Col>
                        </Row>
                        <Divider />
                        <Row>
                            <Col lg={12} md={12} sm={24} xs={24}>
                                <Form
                                    size='large'
                                    form={form}
                                    initialValues={item}
                                    fields={[]}
                                    onFinish={(value) => {
                                        const reqObj: any = fillEn({
                                            ...value,
                                        is_recording_on: value.is_recording_on ? 1 : 0,
                                            start_date_time: value.start_date_time.format('YYYY-MM-DD HH:mm:ss'),
                                            end_date_time: value.end_date_time.format('YYYY-MM-DD HH:mm:ss'),
                                        });

                                        setSaving(true);
                                        API_SERVICE.createMeeting(RouteParams['courseId'], reqObj).then((d) => {
                                            history.goBack();
                                        }).catch((e) => {
                                            notification.error({ message: API_SERVICE.handleErrors(e) });
                                            setSaving(false);
                                        });
                                    }}
                                    layout='vertical'
                                    requiredMark={true}
                                >

                                    <Form.Item
                                        label={t('meeting.titleDe.label')}
                                        name={['title', 'de']}
                                        rules={[
                                            { required: true, message: t('meeting.titleDe.required') },
                                        ]}
                                    >
                                        <Input disabled={!RouteParams['mode']} />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('meeting.title.label')}
                                        name={['title', 'en']}
                                        rules={[
                                        ]}>
                                        <Input disabled={!RouteParams['mode']} />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('meeting.descriptionDe.label')}
                                        name={['description', 'de']}
                                        rules={[
                                            { required: true, message: t('meeting.descriptionDe.required') },
                                        ]}
                                    >
                                        <Input disabled={!RouteParams['mode']} />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('meeting.description.label')}
                                        name={['description', 'en']}
                                        rules={[
                                        ]}>
                                        <Input disabled={!RouteParams['mode']} />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('meeting.isRecordingOn.label')}
                                        name='is_recording_on'
                                        valuePropName={'checked'}
                                        rules={[]}
                                    >
                                        <Switch disabled={RouteParams['mode'] === 'view'} />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('meeting.startDate.label')}
                                        name='start_date_time'
                                        rules={[
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value) {
                                                        return Promise.reject(
                                                            t('meeting.startDate.required'),
                                                        );
                                                    }
                                                    if (moment().subtract('day', 1).unix() < value.unix()) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(
                                                        t('meeting.startDate.shouldBeGreaterThanToday'),
                                                    );
                                                },
                                            }),
                                        ]}
                                    >
                                        <DatePicker showTime={true} />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('meeting.endDate.label')}
                                        name='end_date_time'
                                        rules={[
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value) {
                                                        return Promise.reject(
                                                            t('meeting.endDate.required'),
                                                        );
                                                    }
                                                    if (getFieldValue('start_date_time') && getFieldValue('start_date_time').unix() < value.unix()) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(
                                                        t('meeting.endDate.shouldBeLessThanStartDateTime'),
                                                    );
                                                },
                                            }),
                                        ]}
                                    >
                                        <DatePicker showTime={true} />
                                    </Form.Item>
                                    <br />
                                    {
                                        RouteParams['mode'] && <Form.Item>
                                            <Button
                                                type='primary'
                                                htmlType='submit'
                                                loading={saving || uploading}
                                                shape='round'
                                                size={'large'}
                                                className='submit'
                                            >
                                                {t('genDict.save')}
                                            </Button>
                                        </Form.Item>
                                    }
                                </Form>
                            </Col>
                        </Row> */}
                    </div>
                : <><div>
                    {setFetching(true)}
                    <h5 className="text-center mt-5 mb-5">Permission Denied</h5>
                    {setFetching(false)}
                </div>
            </>
            )}
        </AuthConsumer>
    );
    
}
